"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveBannerStatus = exports.summarizeGlobalBanners = exports.EMPTY_BANNER = exports.BANNER_STATUS_LABEL = exports.UPDATE_BANNER_LIST = void 0;
/** 목록 갱신 이벤트(APP.eventManager) — 등록/수정/삭제 후 발행 */
exports.UPDATE_BANNER_LIST = 'UPDATE_BANNER_LIST';
exports.BANNER_STATUS_LABEL = {
    loading: '확인 중',
    own: '개별 설정',
    inherit: '전체 배너 적용',
    none: '없음',
    error: '조회 실패',
    unknown: '확인 불가',
};
exports.EMPTY_BANNER = {
    class_id: '',
    title: '',
    description: '',
    button_text: '',
    button_link: '',
};
/**
 * 클래스 행들의 조회 결과에서 테넌트별 전체 배너를 유도한다.
 *  - 전체 배너 적용(inherit) 행이 있으면 그 배너가 해당 테넌트의 전체 배너
 *  - 없음(none) 행만 있으면 해당 테넌트에 전체 배너가 없음
 *  - 모두 개별 설정/조회 중/실패면 판정 불가(undefined)
 */
const summarizeGlobalBanners = (rows) => {
    const byTenant = new Map();
    rows.forEach(row => {
        const tenantId = row.klass.tenant_id ?? '';
        const current = byTenant.get(tenantId) ?? { tenantId, banner: undefined, classCount: 0 };
        current.classCount += 1;
        if (row.status === 'inherit' && row.banner) {
            current.banner = row.banner;
        }
        else if (row.status === 'none' && current.banner === undefined) {
            current.banner = null;
        }
        byTenant.set(tenantId, current);
    });
    return Array.from(byTenant.values());
};
exports.summarizeGlobalBanners = summarizeGlobalBanners;
/**
 * 조회 결과로 대상(classId)의 상태를 판정한다.
 * 서버는 개별 설정이 없으면 전체 배너를 대신 돌려주므로 result.class_id 로 구분한다.
 */
const resolveBannerStatus = (classId, banner) => {
    if (!banner)
        return 'none';
    return (banner.class_id ?? '') === classId ? 'own' : 'inherit';
};
exports.resolveBannerStatus = resolveBannerStatus;
